<template>
  <div class="getexper">
    <!-- 体验票 -->
  </div>
</template>

<script>
export default {
  name: 'Getexper',
  data () {
    return {
      experienceTicket: ''
    }
  },
  methods: {
    //
  }
}
</script>

<style lang="scss">
.getexper {
  //
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Getexper.vue